import Vue from "vue";
import Vuex from "vuex";

import map from "./map.module";
import grids from "./grids.module";
import news from "./news.module";
import home from "./home.module";
import user from "./user.module";
import places from "./places.module";
import alerts from "./alerts.module";
import alertsContent from "./alertsContent.module";
import hotspots from "./hotspots.module";
import search from "./search.module";
import topicsv2 from "./topicsv2.module";
import social from "./social.module";
import monitor from "./monitor.module";
import collaboration from "./collaboration.module";
import dayNightOverlay from "./dayNightOverlay.module";
import savedSearch from "./savedSearch.module";
import communication from "./communication.module";
import powerOutage from "./powerOutage.module";
import analysis from "./analysis.module";
import notifications from "./notifications.module";
import targets from "./targets.module";
import time from "./time.module";
import assets from "./assets.module";
import myIncidents from "./myIncidents.module";

Vue.use(Vuex);

export const MODULE_PREFIX_MAP = "map/";
export const MODULE_PREFIX_GRIDS = "grids/";
export const MODULE_PREFIX_NEWS = "news/";
export const MODULE_PREFIX_HOME = "home/";
export const MODULE_PREFIX_USER = "user/";
export const MODULE_PREFIX_PLACES = "places/";
export const MODULE_PREFIX_ALERTS = "alerts/";
export const MODULE_PREFIX_ALERTS_CONTENT = "alertsContent/";
export const MODULE_PREFIX_HOTSPOTS = "hotspots/";
export const MODULE_PREFIX_SEARCH = "search/";
export const MODULE_PREFIX_TOPICS_V2 = "topicsv2/";
export const MODULE_PREFIX_SOCIAL = "social/";
export const MODULE_PREFIX_MONITOR = "monitor/";
export const MODULE_PREFIX_COLLABORATION = "collaboration/";
export const MODULE_PREFIX_DAY_NIGHT_OVERLAY = "dayNightOverlay/";
export const MODULE_PREFIX_SAVED_SEARCH = "savedSearch/";
export const MODULE_PREFIX_COMMUNICATION = "communication/";
export const MODULE_PREFIX_POWER_OUTAGE = "powerOutage/";
export const MODULE_PREFIX_ANALYSIS = "analysis/";
export const MODULE_PREFIX_NOTIFICATIONS = "notifications/";
export const MODULE_PREFIX_TARGETS = "targets/";
export const MODULE_PREFIX_TIME = "time/";
export const MODULE_PREFIX_ASSETS = "assets/";

export const MODULE_PREFIX_MY_INCIDENTS = "myIncidents/";

export default new Vuex.Store({
  modules: {
    map,
    grids,
    news,
    home,
    user,
    places,
    alerts,
    alertsContent,
    hotspots,
    search,
    topicsv2,
    social,
    monitor,
    collaboration,
    dayNightOverlay,
    savedSearch,
    communication,
    powerOutage,
    analysis,
    notifications,
    targets,
    time,
    assets,
    myIncidents,
  },
});
